import {
    GET_PERMISSIONS_FAIL,
    GET_PERMISSIONS_SUCCESS,
    ADD_PERMISSION_SUCCESS,
    ADD_PERMISSION_FAIL,
    UPDATE_PERMISSION_SUCCESS,
    UPDATE_PERMISSION_FAIL,
    DELETE_PERMISSION_SUCCESS,
    DELETE_PERMISSION_FAIL,
   
} from "./actionTypes";

const INIT_STATE = {
    permissions: [],
    error: {},
    loading: true
}

const permissionReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_PERMISSIONS_SUCCESS:
            return {
                ...state,
                permissions: action.payload,
                loading: true
            };

        case GET_PERMISSIONS_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case ADD_PERMISSION_SUCCESS:
            return {
                ...state,
                permissions: [action.payload, ...state.permissions],
            };

        case ADD_PERMISSION_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case UPDATE_PERMISSION_SUCCESS:
            return {
                ...state,
                permissions: state.permissions.map(permission =>
                    permission.id.toString() === action.payload.id.toString()
                        ? { permission, ...action.payload }
                        : permission
                ),
            };

        case UPDATE_PERMISSION_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case DELETE_PERMISSION_SUCCESS:
            return {
                ...state,
                permissions: state.permissions.filter(
                    permission => permission.id.toString() !== action.payload.toString()
                ),
            };

        case DELETE_PERMISSION_FAIL:
            return {
                ...state,
                error: action.payload,
            };
       
        default:
            return state
    }
}

export default permissionReducer;